<template>
  <div class="photovoltaicMonitor">
    <el-row :gutter="common.gutter">
      <el-col :span="4">
        <!--"监控列表" 开始-->
        <div class="container">
          <table class="list">
            <tr>
              <td style="width: 37%">
                <my-title title="监控列表"></my-title>
              </td>
              <td>
                <span class="monitor-number">{{ listData.length || 0 }}</span>
              </td>
            </tr>
          </table>
          <my-divider :height="common.myDividerHeight1"></my-divider>
          <input-with-button :value="listSearchValue" @search="searchList"></input-with-button>
          <my-divider :height="common.myDividerHeight1"></my-divider>
          <StationListWithCircle :height="listHeight" :data="listData" @click="treeClick" :activeIndex="activeIndex" />
        </div>
        <!--"监控列表" 结束-->
      </el-col>
      <el-col :span="13">
        <div :style="mapStyle">
          <map-view :menuData="menuData"></map-view>
        </div>
      </el-col>
      <el-col :span="7">
        <!--"监控状态" 开始-->
        <div class="container ashComWrap">
          <div class="comTitle">
            <h3>监控状态</h3>
          </div>
          <div class="comContentBox">
            <HeadTips v-if="state?.length" :listData="state" />
            <el-empty v-else class="empty" :image-size="80" description="暂无数据"></el-empty>
          </div>
        </div>
        <!--"监控状态" 结束-->

        <my-divider :height="common.myDividerHeight1"></my-divider>

        <!--"视频监控" 开始-->
        <div class="container" :style="videoHeight">
          <my-title title="视频监控"></my-title>
          <my-divider :height="common.myDividerHeight1"></my-divider>
          <span>{{ activeItem.name }}</span>

          <my-divider :height="common.myDividerHeight1"></my-divider>

          <div style="width: 100%;height: 250px;display: inline-block;">
            <el-image v-if="notPlay" style="width: 100%; height: 100%" :src="require('@/assets/images/video/noVideo.svg')"
              fit="fill"></el-image>
            <VideoPlayer v-else :url='videoUrl' :isLive="isLive" :id="videoId" ref="videoRef" />
          </div>
          <template v-if="!notPlay">
            <my-divider height="30px"></my-divider>
            <DateTimePicker @dateChange="dateChange" />
            <my-divider height="30px"></my-divider>
            <table class="container-action">
              <tr>
                <td>
                  <el-button size="medium" @click="changePlayType">{{ isLive ? "回放" : "直播" }}</el-button>
                </td>
                <td>
                  <el-button size="medium" @click="changePlay">{{ isPlay ? "暂停" : "播放" }}</el-button>
                </td>
                <td>
                  <Rate v-if="!isLive" :domId="videoId" />
                </td>
                <td>
                  <el-button size="medium" @click="fullScreen">全屏</el-button>
                </td>
              </tr>
            </table>
          </template>
        </div>
        <!--"视频监控" 结束-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MyDivider from "@/components/MyDivider";
import MyTitle from "@/components/MyTitle";
import MapView from "@/components/zixitong/indoorEnvironment/MapView";
import InputWithButton from "@/components/zixitong/photovoltaicSystem/InputWithButton";
import DateTimePicker from '@/components/DatePicker/DateTimePicker';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer';
import Rate from '@/components/VideoPlayer/Rate';
import HeadTips from "@/components/HeadTips/HeadTips";
import StationListWithCircle from "@/components/zixitong/photovoltaicSystem/StationListWithCircle";
import api from "@/api";
import {
  getProjectVal,
} from "@/assets/js/utils";
export default {
  components: {
    StationListWithCircle,
    InputWithButton,
    MapView,
    MyTitle, MyDivider,
    VideoPlayer,
    Rate,
    HeadTips,
    DateTimePicker
  },
  data() {
    return {
      common: {
        gutter: 10,
        myDividerHeight1: '10px'
      },

      /*"列表" 开始*/
      oriListData: [],
      listSearchValue: '',
      listData: [],
      activeItem: {
        url: "",
        urlBack: ""
      },
      activeIndex: null,
      /*"列表" 结束*/

      /*"监控状态" 开始*/
      state: [
        {
          name: '全部',
          value: 0
        },
        {
          name: '在线',
          value: 0
        },
        {
          name: '离线',
          value: 0
        }
      ],
      /*"监控状态" 结束*/

      /*"视频监控" 开始*/
      videoId: 'videoPVOMonitor',
      notPlay: true,
      timeFormatStr: '',
      isLive: true,
      isPlay: false,
      visibleRate: false,
      //当前播放速率
      rate: 1.0,
      /*"视频监控" 结束*/

      listHeight: '680px',
      mapStyle: 'width: 100%;height: 790px',
      videoHeight: 'height: 630px',
    }
  },
  computed: {
    videoUrl: function () {
      return this.isLive ? this.activeItem.url : this.activeItem.urlBack
    },
    menuData: function () {
      const PVList = this.oriListData
      const PVClick = this.activeItem
      return {
        PVList,
        PVClick
      }
    }
  },
  watch: {
    videoUrl(val) {
      if (!val) {
        this.notPlay = true
      } else {
        if (this.notPlay) {
          this.notPlay = false
        } else {
          this.isPlay = false;
          // this.$refs.videoRef.videoGetExeStatus()
        }
      }
    },
  },
  methods: {
    //监控列表
    async getCameraInfo() {
      let res = await api.PVOSGetAllCameraInfo({
        projectId: getProjectVal('Id'),
      });
      if (res && res.data.code == 200) {
        let on = 0
        let off = 0
        console.log(this.$route.params, "res.data.data----this.$route.params-");
        const newData = res.data.data.map(item => {
          if (item?.active) {
            item.status = "active"
            on++
          } else {
            item.status = "offline"
            off++
          }
          return item
        })
        this.listData = newData
        this.oriListData = newData
        const all = on + off
        this.state = [
          {
            name: '全部',
            value: all
          },
          {
            name: '在线',
            value: on
          },
          {
            name: '离线',
            value: off
          }
        ]
        //处理传入界面的id，初始选中
        if (!!this.$route.params.id) {
          const defaultId = this.$route.params.id
          const index = this._.findIndex(newData, function (o) { return o.id === defaultId; })
          this.activeIndex = index
          const activeItem = newData[index]
          this.activeItem = {
            ...activeItem,
            url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${activeItem?.RTSP || ""}`,
            urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(activeItem?.RTSP || "").replace('Channels', 'tracks')}?${this.timeFormatStr}`
          }
        }
      } else {
        console.log("获取监控列表失败");
      }
    },
    searchList(val) {
      this.listData = this.oriListData.filter(item => item?.name.includes(val))
    },
    treeClick(data = { item, index }) {
      console.log("treeClick--data--", data);
      const { item, index } = data
      this.activeIndex = index
      this.activeItem = {
        ...item,
        url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${item?.RTSP || ""}`,
        urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(item?.RTSP || "").replace('Channels', 'tracks')}?${this.timeFormatStr}`
      }
    },
    dateChange(value) {
      if (value) {
        const starttime = this.$moment(value[0]).format('YYYYMMDDTHHmmss[Z]')
        const endtime = this.$moment(value[1]).format('YYYYMMDDTHHmmss[Z]')
        const newStr = `starttime=${starttime}&endtime=${endtime}`
        this.timeFormatStr = newStr
        const urlBackArr = this?.activeItem?.urlBack.split('starttime=')
        this.activeItem.urlBack = `${urlBackArr[0]}${newStr}`
      } else {
        this.timeFormatStr = ""
        this.activeItem.urlBack = `${urlBackArr[0]}`
      }
      console.log(value, 'dateChange value');
      console.log(this.activeItem, 'dateChange  this.activeItem');
    },
    changePlayType() {
      this.isLive = !this.isLive;
      this.isPlay = false;
    },
    changePlay() {
      try {
        if (this.isPlay) {
          this.$refs.videoRef.player.pause()
        } else {
          this.$refs.videoRef.player.play()
        }
      } catch (error) {
        console.log('---changePlay---error--', error)
      }

      this.isPlay = !this.isPlay
    },
    fullScreen() {
      const element = document.getElementById(this.videoId)
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    heightResize() {
      if (window.innerWidth >= 2560) {
        this.videoHeight = 'height: 1210px'
        this.mapStyle = 'width: 100%;height: 1500px'
        this.listHeight = '1320px'
      } else {
        this.videoHeight = 'height: 630px'
        this.mapStyle = 'width: 100%;height: 790px'
        this.listHeight = '680px'
      }
    }
  },
  created() {
    this.getCameraInfo()
    this.heightResize();
  },
  mounted() {
    this.$bus.$on("getMapClickFun", (data) => {
      const index = this._.findIndex(this.listData, function (o) { return o.id === data.id; })
      this.treeClick({ item: data, index })
    });
    window.addEventListener("resize", this.heightResize);
  },
  beforeDestroy() {
    this.$bus.$off("getMapClickFun");
    window.removeEventListener("resize", this.heightResize);
  },
}
</script>

<style lang="scss" scoped>
$colorActive: #28CCCB;
$colorNotActive: #999999;
$colorAlarm: #EC5453;
$colorMain: #28CCCB;

span.monitor-number {
  color: $colorMain;
  font-size: 22px;
}

button.search {
  background-color: $colorMain;
  color: #FFFFFF;
  border: 1px solid $colorMain;
  border-bottom-left-radius: unset;
  border-top-left-radius: unset;
}

td.container-circle {
  width: 30px;
  text-align: right;
}

table.container-list {
  width: 100%;
}

.el-menu {
  border-right: none;
}

table.container-action {
  width: 100%;
  text-align: center;
}

div.container-name-value {
  text-align: center;
  display: inline-block;
  padding: 10px 35px;
}

span.active {
  background-color: $colorActive;
}

span.inactive {
  background-color: $colorNotActive;
}

span.circle {
  display: inline-block;
  height: 12px;
  width: 12px;
  border-radius: 6px;
}

table.list {
  width: 100%;
  text-align: left;
}

div.container {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 6px;
}

div.photovoltaicMonitor {
  @include setPage;
  min-width: 1640px;
}
</style>
